import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './rich-text.component.scss';
var RichText = /** @class */ (function (_super) {
    tslib_1.__extends(RichText, _super);
    function RichText(element) {
        return _super.call(this, element) || this;
    }
    RichText.prototype.init = function () {
    };
    RichText.prototype.bindEvents = function () {
    };
    return RichText;
}(Base));
export { RichText };



//////////////////
// WEBPACK FOOTER
// ./components/rich-text/rich-text.component.ts
// module id = 564
// module chunks = 0